export default "__VITE_ASSET__Bcdlw3lr__"